import React, { useMemo } from 'react';
import moment from "moment";
import { useTranslation } from "react-i18next";
import { VisitorBooking } from "../data/visitor-booking-service";
import { BodyVerySmall } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';

// Shows which meeting room (and when) a visitor is heading to, for visitors that were
// added from a meeting room booking. Meeting times arrive as UTC and are shown in local time.
export function MeetingRoomVisitorBookingLabel(props: Props) {
  const {booking} = props;
  const {t} = useTranslation();

  const label = useMemo(() => {
    if (!booking.meetingRoomName) {
      return undefined;
    }

    if (booking.meetingStartDateTime && booking.meetingEndDateTime) {
      return t('visitor-booking.meeting-room-label-with-time', {
        room: booking.meetingRoomName,
        from: moment.utc(booking.meetingStartDateTime).local().format('HH:mm'),
        to: moment.utc(booking.meetingEndDateTime).local().format('HH:mm'),
      });
    }

    return t('visitor-booking.meeting-room-label', {room: booking.meetingRoomName});
  }, [t, booking.meetingRoomName, booking.meetingStartDateTime, booking.meetingEndDateTime]);

  if (!label) return null;

  return (
    <BodyVerySmall weight={400} colour={Colours.darkGrey}>{label}</BodyVerySmall>
  )
}

interface Props {
  booking: VisitorBooking;
}
